import { Box, Grid, List, ListItem, Typography } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import MATesting from "../assets/MobAppTesting.jpg";

function MobAppTesting() {
  const { t } = useTranslation();
  const textContainerRef = useRef(null);
  const [textHeight, setTextHeight] = useState(0);

  const testingItems = Array.from({ length: 6 }, (_, index) => ({
    title: t(`ma_testing_title_${index + 1}`), // Translated title
    description: t(`ma_testing_description_${index + 1}`), // Translated description
  }));

  useEffect(() => {
    if (textContainerRef.current) {
      setTextHeight(textContainerRef.current.offsetHeight);
    }
  }, [testingItems]);

  return (
    <>
      <Box display="flex" justifyContent="center" sx={{ mt: 5 }}>
        <Typography variant="h5" fontWeight={500}>
          {t("ma_testing_heading")}
        </Typography>
      </Box>
      <Grid
        container
        sx={{
          py: 3,
          px: { xs: 2, sm: 8, lg: 30 },
          pb: 5,
          gap: { xs: 5, md: 0 },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={MATesting}
            alt="Benefits"
            sx={{
              maxWidth: { xs: "100%", md: "95%" },
              height: { xs: "auto", md: `${textHeight}px` },
              objectFit: "cover", // Ensures the image fits within the height
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          display={"flex"}
          direction={"column"}
          ref={textContainerRef} // Reference for dynamic height calculation
        >
          {/* Description without bullet */}
          <Typography variant="body2" color="text.secondary">
            {t("ma_testing_description")}
          </Typography>
          <List sx={{ ml: 3 }}>
            {testingItems.map((item, index) => (
              <ListItem
                key={index}
                disablePadding
                sx={{ display: "block", mb: 1 }}
              >
                {/* Title as bold with bullet */}
                <Typography variant="body1">&#8226; {item.title}</Typography>
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>
    </>
  );
}

export default MobAppTesting;
